import { render, staticRenderFns } from "./PartnerDetailsFTab.vue?vue&type=template&id=34a6dd72&scoped=true&"
import script from "./PartnerDetailsFTab.vue?vue&type=script&lang=ts&"
export * from "./PartnerDetailsFTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a6dd72",
  null
  
)

export default component.exports